import React from 'react';
import { BsLinkedin } from 'react-icons/bs';
import { FaFacebookF, FaInstagram, FaTwitter } from 'react-icons/fa';
import './footer.css';
const Footer = () => {
  return (
    <footer className='footer__class'>
      <a href="#" className='footer__logo'>AHprohor</a>

      <ul className='permalinks'>
        <li><a href="#">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#experience">Experience</a></li>
        <li><a href="#service">Service</a></li>
        <li><a href="#portfolio">Portfolio</a></li>
        <li><a href="#testimonials">Testimonials</a></li>
        <li><a href="#contact">Contact</a></li>
      </ul>

      <div className='footer__socials'>
        <a href="https://www.facebook.com/profile.php?id=100009207907868" target="_blank" rel="noreferrer"><FaFacebookF></FaFacebookF></a>
        <a href="https://www.instagram.com/ah_prohor/" target="_blank" rel="noreferrer"><FaInstagram></FaInstagram></a>
        <a href="https://twitter.com/?lang=en" target="_blank" rel="noreferrer"><FaTwitter></FaTwitter></a>
        <a href="https://www.linkedin.com/in/ashraful-haque-prohor-220151159/" target="_blank" rel="noreferrer"><BsLinkedin></BsLinkedin></a>
      </div>
      <div className='footer__copyright'>
        <small>&copy; All rights reserved to AHProhor</small>
      </div>
    </footer>
  )
}

export default Footer